import {noop} from '@benchling/js-utils';

import {makeReactContext} from 'lib/makeReactContext';

/**
 * Node-level actions for the procedure run design flowchart. Provided via context so handlers
 * stay stable. Defaults to no-ops outside the editor.
 */
export interface ProcedureRunDesignFlowchartNodeActionsContextValue {
  /** Adds preview state for the downstream nodes that would be removed when removing the given node. */
  onHoverTrashIcon: (nodeId: string) => void;
  /** Clears the removal preview. */
  onUnhoverTrashIcon: () => void;
  /** Opens the removal confirmation flow for a node. */
  onClickTrashIcon: (nodeId: string) => void;
}

export const ProcedureRunDesignFlowchartNodeActionsContext =
  makeReactContext<ProcedureRunDesignFlowchartNodeActionsContextValue>(
    () => ({
      onHoverTrashIcon: noop,
      onUnhoverTrashIcon: noop,
      onClickTrashIcon: noop,
    }),
    'ProcedureRunDesignFlowchartNodeActionsContext'
  );

export const useProcedureRunDesignFlowchartNodeActions =
  ProcedureRunDesignFlowchartNodeActionsContext.useContext;
